import { render, staticRenderFns } from "./service-wages.vue?vue&type=template&id=69f4b660"
import script from "./service-wages.vue?vue&type=script&lang=js"
export * from "./service-wages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports